import {
  type CalendarCriteriaInput,
  buildCalendarCriteria,
} from "./criteria-builder";
import { type ConfigItem, FactSetWidget } from "./FactsetWidget";
export type CalendarItemClickEvent = {
  detail: [
    {
      identifier: string;
    },
  ];
};
type CalendarEventsListProps = {
  onCalendarItemClick?: (event: CalendarItemClickEvent) => void;
  criteria?: CalendarCriteriaInput;
};

export function CalendarEventsList({
  criteria,
  onCalendarItemClick,
}: CalendarEventsListProps) {
  const config: ConfigItem[] = [];

  if (criteria) {
    config.push({
      type: "attribute",
      key: "criteria",
      value: buildCalendarCriteria(criteria),
    });
  }

  if (onCalendarItemClick) {
    config.push({
      type: "event",
      key: "row-click",
      value: onCalendarItemClick,
    });
  }

  return <FactSetWidget config={config} widget="calendar-events-list" />;
}
